export default __webpack_public_path__ + "static/media/border.1588083a.png";